export default "__VITE_ASSET__BP$1sjEL__"